<template>
  <!-- 1. 关注概览（四卡片，全站口径，仅展示） -->
  <section class="report-section">
    <h2 class="section-title">
      <!-- <v-icon size="20" color="var(--color-primary)">mdi-gauge</v-icon> -->
      关注概览
      <span class="section-subtitle">共 {{ stationTotal }} 座电站</span>
    </h2>
    <div class="kpi-grid">
      <div v-for="card in cards" :key="card.key" class="stat-box" :class="card.key">
        <span class="sb-corner-badge">{{ card.stationCount }} 站</span>
        <div class="sb-body">
          <div class="sb-label">{{ card.label }}</div>
          <div class="sb-value-row">
            <span class="sb-val">{{ card.count }}</span>
            <span class="sb-suffix">条</span>
          </div>
        </div>
        <img class="sb-image" :src="getImage(card.key)" :alt="`${card.label}概览`">
      </div>
    </div>
    <div class="recovered-tip">
      <v-icon size="16" color="#388E3C">mdi-check-circle-outline</v-icon>
      今日已自动恢复 {{ recoveredCount }} 条，无需人工处理
    </div>
  </section>
</template>

<script setup>
import overviewImage01 from '@/views/it-operations/summary/tabs/overview/imgs/op-01.png'
import overviewImage02 from '@/views/it-operations/summary/tabs/overview/imgs/op-02.png'
import overviewImage03 from '@/views/it-operations/summary/tabs/overview/imgs/op-03.png'
import overviewImage04 from '@/views/it-operations/summary/tabs/overview/imgs/op-04.png'

defineProps({
  cards: { type: Array, default: () => [] },
  stationTotal: { type: Number, default: 0 },
  recoveredCount: { type: Number, default: 0 },
})

function getImage(key) {
  return {
    total: overviewImage01,
    safety: overviewImage02,
    income: overviewImage03,
    unrecovered: overviewImage04,
  }[key] || overviewImage01
}
</script>

<style scoped lang="scss">
@import './sectionShell.scss';

/* KPI 卡片 */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-box {
  min-width: 0;
  min-height: 88px;
  padding: 20px 22px;
  border-radius: 16px;
  background: linear-gradient(171.53deg, #E7F3FF -10.92%, rgba(247, 251, 255, 0.3) 36.46%);
  border: 1px solid #E9EFFF;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  transition: box-shadow 0.2s, transform 0.2s;
  overflow: hidden;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(58, 104, 255, 0.08);
  }
}

.sb-corner-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 4px 12px 4px 12px;
  border-radius: 0 15px 0 10px;
  background: rgba(58, 104, 255, 0.09);
  color: #3A68FF;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sb-image {
  width: 48px;
  height: 48px;
  object-fit: contain;
  flex-shrink: 0;
}

.sb-body {
  min-width: 0;
  flex: 1;
}

.sb-value-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 4px;
  margin-top: 8px;
}

.sb-val {
  color: #2e2e2e;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sb-suffix {
  color: rgba(46, 46, 46, 0.45);
  font-size: 12px;
  font-weight: 400;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sb-label {
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  color: rgba(46, 46, 46, 0.5);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recovered-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  // background: linear-gradient(171.53deg, #e7f3ff -40.92%, #f7fbff4d 46.46%);
  background: #e7f3ff44;
  border: 1px solid rgba(0, 200, 83, 0.08);
  font-size: 13px;
  color: rgba(46, 46, 46, 0.75);
}

@media (max-width: 900px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
